<template>

<div class="card card-icon h-100">
    <span class="main-icon icon icon-mail "></span>

    <div class="card-body">
        <h3 class="text-uppercase text-gold mb-3">
            Don't miss anything
        </h3>
        <p>
            Subscribe for our newsletter in order to receive all new in the world of AI. We promise to send you only relevent information.
        </p>

        <newsletter></newsletter>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        }

    }
</script>
